import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea1ea7a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginBackground = _resolveComponent("LoginBackground")!
  const _component_LoginBox = _resolveComponent("LoginBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoginBackground, {
      baseRatio: _ctx.baseRatio,
      zoomRatio: _ctx.zoomRatio
    }, null, 8, ["baseRatio", "zoomRatio"]),
    _createVNode(_component_LoginBox, {
      class: _normalizeClass(["login-main-container", { 'login-main-center': _ctx.zoomRatio < 0.66 }])
    }, null, 8, ["class"])
  ]))
}